/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the RankingInfo interface.
 */
export function instanceOfRankingInfo(value) {
    if (!('medianResponseTime' in value) || value['medianResponseTime'] === undefined)
        return false;
    if (!('medianResponseTimeRank' in value) || value['medianResponseTimeRank'] === undefined)
        return false;
    if (!('responseRate' in value) || value['responseRate'] === undefined)
        return false;
    if (!('responseRateRank' in value) || value['responseRateRank'] === undefined)
        return false;
    if (!('nPositiveResponses' in value) || value['nPositiveResponses'] === undefined)
        return false;
    if (!('nPositiveResponsesRank' in value) || value['nPositiveResponsesRank'] === undefined)
        return false;
    return true;
}
export function RankingInfoFromJSON(json) {
    return RankingInfoFromJSONTyped(json, false);
}
export function RankingInfoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'medianResponseTime': json['median_response_time'],
        'medianResponseTimeRank': json['median_response_time_rank'],
        'responseRate': json['response_rate'],
        'responseRateRank': json['response_rate_rank'],
        'nPositiveResponses': json['n_positive_responses'],
        'nPositiveResponsesRank': json['n_positive_responses_rank'],
    };
}
export function RankingInfoToJSON(json) {
    return RankingInfoToJSONTyped(json, false);
}
export function RankingInfoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'median_response_time': value['medianResponseTime'],
        'median_response_time_rank': value['medianResponseTimeRank'],
        'response_rate': value['responseRate'],
        'response_rate_rank': value['responseRateRank'],
        'n_positive_responses': value['nPositiveResponses'],
        'n_positive_responses_rank': value['nPositiveResponsesRank'],
    };
}
